// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var CustomReport$ReactHooksTemplate = require("./CustomReport.res.js");
var ResponseReport$ReactHooksTemplate = require("./ResponseReport.res.js");
var AggregateReport$ReactHooksTemplate = require("./AggregateReport.res.js");

function templateName(t) {
  return t.templateName;
}

function template(t) {
  return t.template;
}

function setTemplateFromName(templateName) {
  switch (templateName) {
    case "AggregateReport" :
        return {
                templateName: templateName,
                template: {
                  TAG: "AggregateReport",
                  _0: AggregateReport$ReactHooksTemplate.empty()
                }
              };
    case "ResponseReport" :
        return {
                templateName: templateName,
                template: {
                  TAG: "ResponseReport",
                  _0: ResponseReport$ReactHooksTemplate.empty()
                }
              };
    default:
      return {
              templateName: "CustomReport",
              template: {
                TAG: "CustomReport",
                _0: CustomReport$ReactHooksTemplate.empty()
              }
            };
  }
}

function templateType(templateType$1) {
  switch (templateType$1.TAG) {
    case "AggregateReport" :
        return AggregateReport$ReactHooksTemplate.templateType;
    case "CustomReport" :
        return CustomReport$ReactHooksTemplate.templateType;
    case "ResponseReport" :
        return ResponseReport$ReactHooksTemplate.templateType;
    
  }
}

function templateFields(template, value) {
  switch (template.TAG) {
    case "AggregateReport" :
        return [
                value.metric,
                value.aggregateFields
              ];
    case "CustomReport" :
        return value.name;
    case "ResponseReport" :
        return [
                value.survey,
                value.campaigns
              ];
    
  }
}

function setAggregateReportTemplate(template) {
  return {
          templateName: "AggregateReport",
          template: {
            TAG: "AggregateReport",
            _0: template
          }
        };
}

function setCustomReportTemplate(template) {
  return {
          templateName: "CustomReport",
          template: {
            TAG: "CustomReport",
            _0: template
          }
        };
}

function setResponseReportTemplate(template) {
  return {
          templateName: "ResponseReport",
          template: {
            TAG: "ResponseReport",
            _0: template
          }
        };
}

function decode(json) {
  var templateName = Json_decode.field("template_type", Json_decode.string, json);
  var template = templateName === AggregateReport$ReactHooksTemplate.templateType ? ({
        TAG: "AggregateReport",
        _0: Json_decode.field("template", AggregateReport$ReactHooksTemplate.decode, json)
      }) : (
      templateName === ResponseReport$ReactHooksTemplate.templateType ? ({
            TAG: "ResponseReport",
            _0: Json_decode.field("template", ResponseReport$ReactHooksTemplate.decode, json)
          }) : ({
            TAG: "CustomReport",
            _0: Json_decode.field("template", CustomReport$ReactHooksTemplate.decode, json)
          })
    );
  return {
          templateName: templateName,
          template: template
        };
}

var templateList = {
  hd: "AggregateReport",
  tl: {
    hd: "CustomReport",
    tl: {
      hd: "ResponseReport",
      tl: /* [] */0
    }
  }
};

exports.templateName = templateName;
exports.template = template;
exports.templateList = templateList;
exports.setTemplateFromName = setTemplateFromName;
exports.templateType = templateType;
exports.templateFields = templateFields;
exports.setAggregateReportTemplate = setAggregateReportTemplate;
exports.setCustomReportTemplate = setCustomReportTemplate;
exports.setResponseReportTemplate = setResponseReportTemplate;
exports.decode = decode;
/* ResponseReport-ReactHooksTemplate Not a pure module */
